// FR-API6a: the read / read+write choice every token-creation form shares, and the label every
// token list shows. A token always carries `read`; `write` is what unlocks the mutating MCP
// tools (the server rejects write-only scope sets). Operator tokens use the `ops:` pair.
import { SegmentedControl } from "@grackle/ui";

export type TokenAccess = "read" | "write";

export function accessToScopes(access: TokenAccess, prefix = ""): string[] {
  return access === "write" ? [`${prefix}read`, `${prefix}write`] : [`${prefix}read`];
}

export function scopesLabel(scopes: string[] | undefined): string {
  const list = scopes ?? [];
  const write = list.some((s) => s === "write" || s === "ops:write");
  if (list.length === 0) return "read + write";
  return write ? "read + write" : "read only";
}

export function TokenAccessPicker({
  value,
  onChange,
  label = "Access",
}: {
  value: TokenAccess;
  onChange: (next: TokenAccess) => void;
  label?: string;
}) {
  return (
    <div className="token-access" role="group" aria-label={label}>
      <div className="token-access-label">{label}</div>
      <SegmentedControl
        value={value}
        onChange={(v) => onChange(v as TokenAccess)}
        options={[
          { value: "read", label: "Read only" },
          { value: "write", label: "Read + write" },
        ]}
      />
    </div>
  );
}
